import getters from "./getters";
import state from "./state";

const mutations = {
  PUSH_INCLUDE(state, String) {
    state.include.push(String);
  },
  PUSH_AXIOS_PING(state, Obj) {
    state.axiosPing.push(Obj);
  },
  REMOVE_AXIOS_PING(state, Index) {
    state.axiosPing.splice(Index, 1);
  },
  LOADING_SHOW(state, Boolean) {
    state.loading = Boolean;
  },
  SET_BACK_FLAG(state, Boolean) {
    state.backFlag = Boolean;
  },
  SET_LANGUAGE(state, String) {
    state.language = String;
  },
  SET_TOKEN(state, String) {
    state.token = String;
  },
  GET_USER_INFO(state, obj) {
    if (typeof obj === "string" && obj == "delete") {
      state.userInfo = {};
      state.usableMoney = 0;
    } else if (typeof obj === "object") {
      // state.userInfo = obj;
      if (JSON.stringify(state.userInfo) == "{}") {
        state.userInfo = obj;
      } else {
        for (var key in obj) {
          state.userInfo[key] = obj[key];
        }
      }
    }
    console.log("==== 用户信息 ====", state.userInfo);
  },

  GET_PLATFORM_INFO(state, obj) {
    state.platformInfo = obj;
    console.log("==== 平台信息 ====", obj);
  },
  SET_MONEY(state, obj) {
    state.usableMoney = obj;
    console.log("==== 帐户金额 ====", obj);
  }
};
export default {
  state,
  mutations,
  getters
};
